module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADJSURBVEhL7ZQhDgIxEEWnJHRPsXUY7gMJEocEhwOHROKQiD0PsLvBcQxCgPmkErYzLStI9pn5yTT/NRWljv/g4uzQRzU9P79SOrt+EBWxEuPnR1DOB1bIPE98m/Hgeju/l0IaBYAlSz60QY6RBAWgctmc6LlF1kpEAlDl/RkZs0PWSMQCwJIpS/bIUolKAMrcToyhA7JEwnsdXH73UYTuiZwd8SiQf/5EMeVAJIgtB0FBSjloFKSWi6jzbFE7e0z5UYO0Wt7RMkQvHqNPFIYqYiIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/icons/arrow.png
// module id = 9T3I
// module chunks = 18